import React from "react";
import ReactDOM from "react-dom";
import { Grid, Loading } from "@sumprio/ui";
import "./PageLoadingOverlay.scss";

export default function PageLoadingOverlay() {
  const overlay = (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent="center"
      className="main-content-loading-overlay"
    >
      <Loading variant="lineSpinner" size="xl" />
    </Grid>
  );

  return ReactDOM.createPortal(overlay, document.body);
}
